/**
 * Formatters para uso nos relatórios (PDF e XLSX) e nas tabelas de
 * pré-visualização. Locale pt-BR, currency BRL. Imports puros, sem deps
 * externas — facilita testes unitários sem mock.
 */

export function formatMoney(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '';
  return n.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Parse ISO `YYYY-MM-DD` (sem TZ) pra Date sem deslocamento de fuso. */
function parseIsoDate(iso: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!m) return null;
  const [, y, mo, d] = m;
  return new Date(Number(y), Number(mo) - 1, Number(d));
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = parseIsoDate(iso);
  if (!d) return iso;
  return d.toLocaleDateString('pt-BR');
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

/** Aceita `"HH:MM"` ou `"HHHH:MM"`; passa pra string limpa. */
export function formatHours(value: string | null | undefined): string {
  if (!value) return '';
  return value.trim();
}

const MESES_PT = [
  'JANEIRO',
  'FEVEREIRO',
  'MARÇO',
  'ABRIL',
  'MAIO',
  'JUNHO',
  'JULHO',
  'AGOSTO',
  'SETEMBRO',
  'OUTUBRO',
  'NOVEMBRO',
  'DEZEMBRO',
];

export function formatPeriodo(mes: number, ano: number): string {
  const m = MESES_PT[mes - 1];
  if (!m) return `${mes}/${ano}`;
  return `${m}/${ano}`;
}

/** Sanitiza nome de arquivo: remove acentos, separa por hífen. */
export function buildFilename(prefix: string, ...parts: Array<string | number>): string {
  const ascii = (s: string): string =>
    s
      .normalize('NFD')
      .replace(new RegExp('[\\u0300-\\u036f]', 'g'), '')
      .replace(/[^a-zA-Z0-9-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  const all = [prefix, ...parts.map((p) => String(p))].map(ascii).filter(Boolean);
  return all.join('_');
}
